import { render } from "./ModalReplacement.vue?vue&type=template&id=cfc80cca&scoped=true"
import script from "./ModalReplacement.vue?vue&type=script&lang=js"
export * from "./ModalReplacement.vue?vue&type=script&lang=js"

import "./ModalReplacement.vue?vue&type=style&index=0&id=cfc80cca&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfc80cca"]])

export default __exports__